import {AxiosResponse} from 'axios'
import axios from './_axios'
import {prepareParams} from './_internal'
import {AxiosResult, Ord, Paginate} from './_types'

const prefix = process.env.REACT_APP_REPORTS_BASE_URL

type CameraStat1 = {
  id: number
  status: string
  count: number
}

type CameraReports = {
  statuses: CameraStat1[]
  online: number
  offline: number
}

type StatsParams = {
  filter?: {
    companyId?: number
  }
}

export type CountByCameraParams = {
  filter?: {
    companyId?: number
  }
  start?: string
  end?: string
  aggregateBy: 'client' | 'camera'
  orderBy: 'DESC' | 'ASC'
}

export type EventFeedbackParams = {
  period: string
  filter?: {
    companyId?: number
  }
}

export type EventFeedBack = {
  period: string
  reports: Reports[]
}

type Reports = {
  userId: number
  name: string
  current: number
  previous: number
}

export type EventChart = {
  companyId: number
  aggregation: string
  total: number
  series: EventSerieTypes | []
}

export type EventSerieTypes = {
  Eventos: EventSerie[]
  Despachado: EventSerie[]
  Erro: EventSerie[]
  Expirado: []
  Ignorado: EventSerie[]
  Iniciado: EventSerie[]
  Processado: EventSerie[]
}

export type EventSerie = {
  count: number
  year: number
  month: number
  week: number
  day: number
  hour: number
  minute: number
}

export type GetEventsChartsParams = {
  end: string
  start: string
  filter?: {
    status?: string[]
    companyIds?: number[]
  }
}

export type GetEventsChartsMaxParams = {
  end: string
  start: string
  orderBy: Ord
  aggregateBy?: string
  operation?: string
  filter?: {
    companyId: number
  }
}

export type EventCamMax = {
  cameraId?: number
  clientId?: number
  data: number
}

export type PeopleCountParams = {
  end: string
  start: string
  filter?: {
    cameraIds?: Array<number | undefined>
    clientIds?: Array<number | undefined>
  }
}

export type GenderCountParams = {
  end: string | number
  start: string | number
  filter?: {
    cameraIds?: Array<number | undefined>
    clientIds?: Array<number | undefined>
  }
  countByDay?: boolean
}

export type CountByCategoriesParams = {
  end: string
  start: string
  groupBy: string
  categorizeBy: string
  filter?: {
    cameraIds?: Array<number | undefined>
    clientIds?: Array<number | undefined>
  }
}

export type RateByGroups = {
  end: string
  start: string
  groupBy: string
  filter?: {
    cameraIds?: Array<number | undefined>
    clientIds?: Array<number | undefined>
  }
}

export type RateBySensitiveData = {
  end: string
  start: string
  groups: Array<string>
  filter?: {
    cameraIds?: Array<number | undefined>
    clientIds?: Array<number | undefined>
  }
}

export type RateByGroupsDTO = {
  series: Array<number>
  labels: Array<string>
}

export type CountByCategoriesDTO = {
  series: Array<{
    name: string
    data: Array<number>
  }>
  categories: Array<string | number>
}

export type RateGenderByDayPeriodDTO = [
  {
    quantity: number
    period: string
    gender: string
  },
]

export type getDetectorCounts = {
  start: string
  end: string
  filter?: {
    cameraIds?: number[]
    clientIds?: number[]
    companyIds?: number[]
  }
}

export type DetectorCountsObjects = {
  objects: DetectorCountObjects[]
}

export type DetectorCountObjects = {
  objectType: string
  cameraId: number
  count: string
}

export interface PersonDetectionsDTO {
  detections: number
}

export interface EpiDetectionsDTO {
  detections: number
}

export interface AgeAndGenderDetectionsDTO {
  male: {[k: string]: number}
  female: {[k: string]: number}
  undetermined: {[k: string]: number}
  averageAge: number
}

export interface FaceDetectionsDTO {
  detections: number
  recognizedFaces: number
  allowFaces: number
  notAllowFaces: number
  unkownFaces: number
}

export interface LprDetectionsDTO {
  detections: number
  allowPlates: number
  notAllowPlates: number
}

export interface CountByCameraDTO {
  cameraId?: number
  clientId?: number
  data: number
}
export interface SeriesByGenderDTO {
  result: Array<{
    name: string
    group: string
    data: number[]
  }>
  categories: string[]
}
export interface SeriesByObjectDTO {
  data: Record<string, Array<number>> | null
  categories: string[]
}
export interface SeriesByFaceDTO {
  result: Array<{
    name: string
    group: string
    data: number[]
  }>
  categories: string[]
}
type ObjectsCountDTO = Record<string, number>

interface SeriesByStatusDTO {
  result: Array<{
    name: string
    group: string
    data: number[]
  }>
  categories: string[]
}
export interface SeriesByAgeDTO {
  series: Array<{
    name: string
    group: string
    data: number[]
  }>
  categories: string[]
  avarageAge: number
  totalMale: number
  totalFemale: number
  totalUndetermined: number
}

export type ExportEventsReportDTO = {
  search?: {
    cameraName?: string
    id?: number
    clientName?: string
  }
  filter?: {
    companyIds?: Array<number>
    eventTypeIds?: Array<string>
    cameraIds?: Array<number>
    statuses?: Array<string>
    statusCameras?: string
    isOnline?: boolean
  }
  start?: string
  end?: string
}

type DefaultFilterParams = {
  filter: {
    companyIds?: Array<number>
    clientIds?: Array<number>
    cameraIds?: Array<number>
    listId?: Array<number>
    status?: Array<string>
    objectTypes?: Array<string>
    range?: string
  }
  start?: string
  end?: string
  offset?: number
  timeZone?: string
  getFrom?: string
}

type SynteticFilterParams = {
  filter: {
    companyIds?: Array<number>
  }
  actual: {
    start: string
    end: string
  }
  last: {
    start: string
    end: string
  }
}

type CountingObjectsResponse = {
  data: Record<string, number[]>
  categories: string[]
}

export type HeatmapDataResponse = {
  cameraId: number
  width: number
  height: number
  detections: Record<string, Array<Array<number>>>
}

export type CountObjectsResponse = {
  cameraId: number
  cameraName: string
  label: string
  count: string
}
export type PermanencyAvgResponse = {
  cameraId: number
  cameraName: string
  time: string
}

export type CountingFacesResponse = {
  total: DataCounting
  unique: DataCounting
  employees: DataCounting
}

export type OnlyTotalsFromCountingResponse = {
  total: number
  unique: number
  employees: number
  cameraIds: number[]
}

type DataCounting = {
  today: number
  yesterday: number
  last7d: number
  last30d: number
  lastYear: number
  range: string[]
}

type HistogramResponse = {
  range: Date[]
  total: number[]
}

type HeatmapResponse = {
  range: Date[]
  total: number[]
}

export type SyntheticResponse = {
  name: string
  actualResult: number
  lastResult: number | null
  percentage: number | null
  delta: number | null
}

export class ReportsEndpoint {
  async camerasReports(params: StatsParams): Promise<AxiosResult<CameraReports>> {
    return await axios.get(`${prefix}/cameras/count`, {params: prepareParams(params)})
  }

  async countByCamerasReports(params: CountByCameraParams): Promise<AxiosResult<Array<CountByCameraDTO>>> {
    return await axios.get(`${prefix}/events/count-by-camera`, {params: prepareParams(params)})
  }

  async getSeriesByObject(params: DefaultFilterParams): Promise<AxiosResult<SeriesByObjectDTO>> {
    return await axios.get(`${prefix}/events/series-by-object`, {params: prepareParams(params)})
  }

  async getSeriesByFace(params: DefaultFilterParams): Promise<AxiosResult<SeriesByFaceDTO>> {
    return await axios.get(`${prefix}/facial/series-by-face`, {params: prepareParams(params)})
  }

  async getSeriesByGender(params: DefaultFilterParams): Promise<AxiosResult<SeriesByGenderDTO>> {
    return await axios.get(`${prefix}/facial/series-by-age-and-gender`, {params: prepareParams(params)})
  }

  async getDashboardDetectionsExportFile(params: DefaultFilterParams): Promise<AxiosResponse<Blob>> {
    return await axios.get(`${prefix}/export/dashboard/detections`, {params: prepareParams(params), responseType: 'arraybuffer'})
  }

  async getFacialDetectionsReport(params: DefaultFilterParams): Promise<AxiosResponse<Blob>> {
    return await axios.get(`${prefix}/export/facial`, {params: prepareParams(params), responseType: 'arraybuffer'})
  }

  async getDashboardEventsExportFile(params: DefaultFilterParams): Promise<AxiosResponse<Blob>> {
    return await axios.get(`${prefix}/export/dashboard/events`, {params: prepareParams(params), responseType: 'arraybuffer'})
  }

  async getEventsReport(params: ExportEventsReportDTO): Promise<AxiosResponse<Blob>> {
    return await axios.get(`${prefix}/export/events`, {params: prepareParams(params), responseType: 'arraybuffer'})
  }

  async getObjectsCount(params: DefaultFilterParams): Promise<AxiosResult<ObjectsCountDTO>> {
    return await axios.get(`${prefix}/events/count-by-object`, {params: prepareParams(params)})
  }

  async getCountByObjectTypes(params: DefaultFilterParams): Promise<AxiosResult<number>> {
    return await axios.get(`${prefix}/events/vehicles-count`, {params: prepareParams(params)})
  }

  async getSeriesByStatus(params: DefaultFilterParams): Promise<AxiosResult<SeriesByStatusDTO>> {
    return await axios.get(`${prefix}/events/series-by-status`, {params: prepareParams(params)})
  }

  async getLprDetections(params: DefaultFilterParams): Promise<AxiosResult<LprDetectionsDTO>> {
    return await axios.get(`${prefix}/lpr/count`, {params: prepareParams(params)})
  }

  async getAgeAndGenderDetections(params: DefaultFilterParams): Promise<AxiosResult<SeriesByAgeDTO>> {
    return await axios.get(`${prefix}/facial/histogram-by-age-and-gender`, {params: prepareParams(params)})
  }

  async getFaceDetections(params: DefaultFilterParams): Promise<AxiosResult<FaceDetectionsDTO>> {
    return await axios.get(`${prefix}/facial/count`, {params: prepareParams(params)})
  }

  async eventCharts(params: GetEventsChartsParams): Promise<AxiosResult<Paginate<EventChart>>> {
    return axios.get(`${prefix}/events/count`, {params: prepareParams(params)})
  }

  async eventCamMax(params: GetEventsChartsMaxParams): Promise<AxiosResult<EventCamMax[]>> {
    return axios.get(`${prefix}/events/aggregation`, {params: prepareParams(params)})
  }

  async getDetectorCounts(params: getDetectorCounts): Promise<AxiosResponse<{objects: CountObjectsResponse[]}>> {
    return await axios.get(`${prefix}/tracker/count`, {
      params: prepareParams(params),
    })
  }

  async getCountingObjectBySeries(params: DefaultFilterParams): Promise<AxiosResponse<CountingObjectsResponse>> {
    return await axios.get(`${prefix}/tracker/series`, {params: prepareParams(params)})
  }

  async getPermanencyAvg(params: DefaultFilterParams): Promise<AxiosResponse<{objects: PermanencyAvgResponse[]}>> {
    return await axios.get(`${prefix}/permanency/average`, {params: prepareParams(params)})
  }

  async getHeatmapData(params: {cameraId: number; start: string; end: string}): Promise<AxiosResult<HeatmapDataResponse>> {
    return await axios.get(`${prefix}/heatmap`, {params: prepareParams(params)})
  }

  // sales apportunities - dashboard

  async getPersonalizedAgeAndGenderCounting(params: DefaultFilterParams): Promise<AxiosResult<SeriesByAgeDTO>> {
    return await axios.get(`${prefix}/facial/aggregated/histogram-and-count-by-ages-ranges`, {params: prepareParams(params)})
  }

  async getPersonalizedCountingFaces(params: DefaultFilterParams): Promise<AxiosResult<CountingFacesResponse>> {
    return await axios.get(`${prefix}/facial/aggregated/fixed-ranges-count`, {params: prepareParams(params)})
  }

  async getOnlyTotalsFromCountingFaces(params: DefaultFilterParams): Promise<AxiosResult<OnlyTotalsFromCountingResponse>> {
    return await axios.get(`${prefix}/facial/aggregated/fixed-ranges-totals`, {params: prepareParams(params)})
  }

  async getHeatmapFaces(params: DefaultFilterParams): Promise<AxiosResult<HeatmapResponse>> {
    return await axios.get(`${prefix}/facial/aggregated/heatmap-by-week-and-hours`, {params: prepareParams(params)})
  }

  async getHistogramFaces(params: DefaultFilterParams): Promise<AxiosResult<HistogramResponse>> {
    return await axios.get(`${prefix}/facial/aggregated/histogram-by-ranges`, {params: prepareParams(params)})
  }

  async getSyntheticData(params: SynteticFilterParams): Promise<AxiosResult<SyntheticResponse[]>> {
    return await axios.get(`${prefix}/facial/aggregated/synthetic/aggregate-clients`, {params: prepareParams(params)})
  }

  async getExportFacialDetectionsCountingAggregated(params: DefaultFilterParams): Promise<AxiosResponse<Blob>> {
    return await axios.get(`${prefix}/export/facial/aggregated-count`, {params: prepareParams(params), responseType: 'arraybuffer'})
  }

  async getExportFacialDetectionsAggreatedByHours(params: DefaultFilterParams): Promise<AxiosResponse<Blob>> {
    return await axios.get(`${prefix}export/facial/aggregated-by-hours`, {params: prepareParams(params), responseType: 'arraybuffer'})
  }
}
